export enum MonthlyDeliveriesNumber {
  ZERO_TO_FIFTY = '0-50',
  FIFTY_TO_ONE_HUNDRED = '50-100',
  ONE_HUNDRED_TO_TWO = '100-200',
  TWO_HUNDRED_TO_THREE = '200-300',
  THREE_HUNDRED_AND_MORE = '300+'
}

export enum Industry {
  RESTAURANT = 'restaurant',
  GROCERY = 'grocery',
  ECOMMERCE = 'ecommerce',
  PHARMACY = 'pharmacy',
  RETAIL = 'retail',
  FLORIST = 'florist',
  MARKETPLACE = 'marketplace',
  OTHER = 'other'
}

export enum JobTitle {
  OWNER = 'owner',
  DIRECTOR = 'director',
  MANAGER = 'manager',
  ADMINISTRATOR = 'administrator',
  COORDINATOR = 'coordinator',
  SPECIALIST = 'specialist',
  SUPERVISOR = 'supervisor',
  ASSISTANT = 'assistant'
}
